import { environment } from "../../environments/environment";

export const API_URL = environment.apiUrlv2;
export const API_URLv2 = environment.apiUrlv2;

export const API_LOGIN = '/login'
export const API_USER = '/users';
export const API_USER_INFO = '/me';
export const API_USER_RECOVER_PASSWORD = '/recoverPassword';
export const API_USER_PERSONAL_INFO = '/personalInfo';
export const API_USER_PERSONAL_PROFILE = '/profile';
export const API_USER_MAILING_PREFERENCES = '/mailingPreferences';
export const API_USER_SENSITIVE_CONTENT = '/sensitiveContent';
export const API_USER_UPDATE_PASSWORD = '/updatePassword';
export const API_USER_REGISTER_CONFIRM = '/registrationConfirm';
export const API_USER_SEND_VALIDATION_EMAIL = '/sendValidationEmail';
export const API_ARTISTS = '/artists';
export const API_PROMOTIONS = '/promotions';
export const API_STATISTICS = '/stats';
export const API_ARTISTS_MEDIAS = '/medias';
export const API_ARTISTS_SHOWCASE = '/showcase';
export const API_ARTIST_COLLECTIONS = '/collections';
export const API_ARTIST_COLLECTIONS_PUBLISH = '/publish';
export const API_ARTIST_COLLECTIONS_UNPUBLISH = '/unpublish';
export const API_TAGS = '/tags';
export const API_CLASSIFICATIONS = '/classifications';
export const API_CONSTANTS = '/constants';
export const API_COUNTRIES = '/countries';
export const API_NEWSLETTER = '/newsletters';
export const API_CONTACT_US = '/sendEmail';
export const API_ACCOUNT = '/account';
export const API_RECEIPTS = '/receipts';
export const API_INVOICES = '/invoices';
export const API_BILLING = '/billing';
export const API_VERIFY = '/verify';
export const API_SUBSCRIPTIONS = '/subscriptions';
export const API_SIGNED = '/signed';
export const API_CONTRACT = '/contract';
export const API_IMAGE_MANAGER = '/imageManager';
export const API_EARNINGS = '/earnings';
export const API_CONTENT_ACTIVITY = '/contentActivity';
export const API_AUDIENCE = '/audience';
export const API_RRSS = '/rrss';

export const USER_TOKEN = 'windowsight.usertoken';
export const USER_DATA = 'windowsight.userpreferences';
export const USER_INFO = 'windowsight.userinfo';
export const WINDOWSIGHT_APP = 'windowsight.usingapp';
export const ARTIST_INFO = 'windowsight.userartist';
export const USER_REGISTRATION_DATA = 'windowsight.registrationdata';
export const USER_REGISTRATION_EMAIL = 'windowsight.registrationemail';
export const ARTIST_PROMOTIONS = 'windowsight.artistpromotions';
export const ARTIST_CODE = 'windowsight.artistcode';
export const PROMOTION_CODE = 'windowsight.promotion.code';
export const COOKIE_USER_LOGGED = 'windowsight.user.logged';
export const COOKIE_USER_AVATAR = 'windowsight.user.avatar';
export const COOKIE_USER_TYPE = 'windowsight.user.type';
export const USER_TYPE_USER = 'user';
export const USER_TYPE_ARTIST = 'artist';
export const USER_TYPE_ADMIN = 'admin';
export const USER_STATUS_ID = 'windowsight.user.statusArtist';
export const APP_CONSTANTS = 'windowsight.constants';
export const WELCOME_POPUP = 'windowsight.loggedbefore';

export const WEB_URL_MANAGER = '/image-manager';
export const WEB_MANTEINANCE_URL = 'https://windowsight.com/under-manteinance/'

export const GUIDE0_URL = '/documents/guide0.pdf';
export const GUIDE1_URL = '/documents/guide1.pdf';
export const GUIDE2_URL = '/documents/guide2.pdf';
export const GUIDE3_URL = '/documents/guide3.pdf';
export const GUIDE4_URL = '/documents/guide4.pdf';
export const GUIDE5_URL = '/documents/guide5.pdf';
export const GUIDE6_URL = '/documents/guide6.pdf';

export const PRICE = 16.99;

export const PREMIUM_ROLE = 'PREMIUM';
export const BASIC_ROLE = 'BASIC';
export const PREMIUM_TRIAL_PERIOD_ROLE = 'PREMIUM_TRIAL_PERIOD';
export const ON_HOLD_ROLE = 'ON_HOLD';
export const PREMIUM_PENDING_TO_GO_FREE_ROLE = 'PREMIUM_PENDING_TO_GO_FREE';
export const PREMIUM_PENDING_TO_GO_BASIC_ROLE = 'PREMIUM_PENDING_TO_GO_BASIC';
export const BASIC_PENDING_TO_GO_FREE_ROLE = 'BASIC_PENDING_TO_GO_FREE';
export const PREMIUM_ARTIST_ROLE = 'PREMIUM_ARTIST';
export const FREE_ROLE = 'FREE';
export const BUSINESS_ROLE = "BUSINESS";

export const APP_STORE_GOOGLE = 'https://play.google.com/store/apps/details?id=com.windowsight.windowsight';
export const APP_STORE_APPLE = 'https://apps.apple.com/us/app/windowsight-art-for-home/id1503527298';
